import { Badge, type BadgeProps } from './Badge.tsx'
import { PRIORITY_LABELS, PRIORITY_VARIANTS, type Priority } from '@/styles/tokens.ts'

interface PriorityBadgeProps extends Omit<BadgeProps, 'variant' | 'children'> {
  priority: Priority
  label?: string
}

export function PriorityBadge({ priority, label, ...props }: PriorityBadgeProps) {
  return (
    <Badge variant={PRIORITY_VARIANTS[priority]} {...props}>
      {label ?? PRIORITY_LABELS[priority]}
    </Badge>
  )
}
